import { EnumBase } from 'hay-core-react';
class ConfiguracaoRequercpfEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.requercpf.desativado',
                'main.configuracao.requercpf.opcional',
                'main.configuracao.requercpf.obrigatorio',
            ],
            'main.configuracao.requercpf.desativado'
        );
    }
}

const instance = new ConfiguracaoRequercpfEnum();
export default instance;
